import React from "react";
import InvestorsHero from "./InvestorsHero";
import InvestorVaultAccess from "./InvestorVaultAccess";
import InvestorArchitecture from "./InvestorArchitecture";
import Contact from "../common/Contact";
import Footer from "../common/Footer";
import ProofOfPerformance from "../home/ProofOfPerformance";

const PrivateInvestors = () => {
  return (
    <>
      <InvestorsHero />
      <InvestorVaultAccess />
      <InvestorArchitecture />
      <ProofOfPerformance/>
      <Contact />
      <Footer />
    </>
  );
};

export default PrivateInvestors;
